import { useEffect, useState } from 'react'

export const useToggleBar = (items, defaultItem = null) => {
    const [buttons, setButtons] = useState([])
    const [selected, setSelected] = useState(null)

    useEffect(() => {
        setButtons(items)
        if (defaultItem) setSelected(defaultItem)
    }, [])

    const onChange = (event, newSelection) => {
        if (!newSelection) newSelection = selected
        setSelected(newSelection)
    }

    return { buttons, selected, onChange }
}